import { render, staticRenderFns } from "./pandaIdolMerchantMenuList.vue?vue&type=template&id=ba8affd8&scoped=true"
import script from "./pandaIdolMerchantMenuList.vue?vue&type=script&lang=ts"
export * from "./pandaIdolMerchantMenuList.vue?vue&type=script&lang=ts"
import style0 from "./pandaIdolMerchantMenuList.vue?vue&type=style&index=0&id=ba8affd8&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba8affd8",
  null
  
)

export default component.exports